<template>
  <v-card outlined style="border-radius: 0px">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Lista Domande </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <span v-if="items_domande.length > 0">
        <v-row
          align="center"
          justify="start"
          :key="d.is_domanda"
          v-for="d in items_domande"
        >
          <div class="mb-3" style="width: 100%">
            <div style="text-align: left">
              <b>{{ d.idx }}. {{ d.domanda }}</b>
            </div>
            <div style="text-align: left">
              {{ d.risposta }}
              <v-btn @click="showImageViewer(d.img_risposta)" icon v-if="d.img_risposta != '' && d.img_risposta != null">
                <v-icon color="primary"> mdi-image </v-icon>
              </v-btn>
            </div>
          </div>
        </v-row>
      </span>
      <span v-else>Non ci sono attualmente domande da riepilogare</span>
    </v-card-text>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ListaDomande",
  components: { SnackbarQV },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    work_order_sel: { type: Object, default: () => {} },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
      items_domande: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.getDomande();
        }
      },
    },
  },
  methods: {
    getDomande() {
      const request = {
        controller: "Questionario",
        method: "POST",
        richiesta: {
          action: "getgrouphistory",
          token: localStorage.user_token,
          id_commessa: this.work_order_sel.id_commessa,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_domande = new Array();

            /* Imposto un indice variabile che userò per
             * assegnare l'indice a ogni domanda / risposta. */
            let idx_tmp = 0;

            res.data.result.forEach((d) => {
              /* Se non ci sono già altre domande di questo test
               * nell'array faccio ripartire l'indice da 0. */
              if (
                this.items_domande.filter((e) => e.id_modulo == d.id_modulo)
                  .length == 0
              ) {
                idx_tmp = 0;
              }

              idx_tmp++;
              d.idx = idx_tmp;
              this.items_domande.push(d);
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    showImageViewer(arg){
      this.$viewerApi({
          options: {
            toolbar: true,
            url: "data-source",
            initialViewIndex: 0,
          },
          images: [{ "data-source": arg }],
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>